// extracted by css-extract-rspack-plugin
export default {"svg":"svg--csghoj03JkjMBlGS","svgCircle":"svg-circle--j7Ihh3ZazMsh3_7D","svgCircleColored":"svg-circle-colored--cLebE9qMQtIKYwFF"};